import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import logo from "../assets/images/achal_logo.png";
import {
  FiStar, FiDownload, FiUser, FiCalendar,
  FiCheckCircle, FiMessageSquare, FiTool, FiHash,
  FiFilter, FiRefreshCw, FiAlertCircle, FiMapPin,
  FiAward, FiTrendingUp
} from "react-icons/fi";

const GOLD = "#D4AF37";
const DARK = "#1E293B";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterRating, setFilterRating] = useState("All");
  const hodName = localStorage.getItem("full_name") || "Authorized HOD";

  useEffect(() => { fetchReviews(); }, []);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const res = await API.get("/hod/reviews");
      if (res.data.success) setReviews(res.data.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const filteredReviews = filterRating === "All"
    ? reviews
    : reviews.filter(r => r.rating === parseInt(filterRating));

  const avgRating = reviews.length > 0
    ? (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1)
    : "0.0";

  const fiveStarCount = reviews.filter(r => r.rating === 5).length;

  // ─────────────────────────────────────────────────────────────
  //  PREMIUM LUXURY RECEIPT TICKET — CENTERED, WHITE BG, GOLD
  // ─────────────────────────────────────────────────────────────
  const downloadProfessionalTicket = (t) => {
    const printWin = window.open("", "_blank");

    const formattedDate = new Date(t.created_at).toLocaleString("en-IN", {
      day: "2-digit", month: "long", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });

    const stars = (rating) =>
      [1, 2, 3, 4, 5]
        .map(i => `<span style="color:${i <= rating ? "#D4AF37" : "#E2E8F0"};font-size:22px;line-height:1;">★</span>`)
        .join("");

    const docId = `AJ-${t.id}-${Date.now()}`;

    printWin.document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <title>Achal Jewels · Ticket ${t.ticket_code}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Inter:wght@400;500;600;700;800;900&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    body {
      font-family: 'Inter', sans-serif;
      background: #EDE9E0;
      min-height: 100vh;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 52px 24px;
      color: #1E293B;
    }

    .ticket {
      width: 680px;
      background: #FFFFFF;
      border-radius: 28px;
      overflow: hidden;
      position: relative;
      box-shadow:
        0 0 0 1px rgba(212,175,55,0.3),
        0 8px 32px rgba(0,0,0,0.10),
        0 32px 80px rgba(0,0,0,0.08);
    }

    /* GOLD LINES */
    .gold-top {
      height: 6px;
      background: linear-gradient(90deg, #B8921A 0%, #F5D76E 30%, #D4AF37 55%, #F5D76E 75%, #B8921A 100%);
    }
    .gold-bottom {
      height: 6px;
      background: linear-gradient(90deg, #F5D76E 0%, #D4AF37 30%, #B8921A 55%, #D4AF37 75%, #F5D76E 100%);
    }

    /* WATERMARK */
    .watermark {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-28deg);
      font-family: 'Playfair Display', serif;
      font-size: 80px;
      font-weight: 900;
      color: rgba(212,175,55,0.035);
      pointer-events: none;
      letter-spacing: 6px;
      white-space: nowrap;
      text-transform: uppercase;
      user-select: none;
      z-index: 0;
    }

    /* All inner content sits above watermark */
    .gold-top, .gold-bottom, .header, .meta-band, .perforation, .body, .footer { position: relative; z-index: 1; }

    /* HEADER */
    .header {
      padding: 44px 56px 38px;
      text-align: center;
    }
    .logo-img {
      height: 60px;
      width: auto;
      object-fit: contain;
      display: block;
      margin: 0 auto 20px;
    }
    .brand-name {
      font-family: 'Playfair Display', serif;
      font-size: 28px;
      font-weight: 900;
      letter-spacing: 10px;
      color: #1E293B;
      text-transform: uppercase;
      margin-bottom: 6px;
    }
    .brand-sub {
      font-size: 9px;
      letter-spacing: 4px;
      color: #D4AF37;
      font-weight: 800;
      text-transform: uppercase;
      margin-bottom: 20px;
    }
    .doc-badge {
      display: inline-block;
      background: #1E293B;
      color: #D4AF37;
      font-size: 9px;
      font-weight: 900;
      letter-spacing: 3px;
      text-transform: uppercase;
      padding: 8px 22px;
      border-radius: 100px;
    }

    /* META BAND */
    .meta-band {
      background: #FAFAF7;
      border-top: 1px solid #F0EBD8;
      border-bottom: 1px solid #F0EBD8;
      padding: 20px 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .mb-block { }
    .mb-block.center { text-align: center; }
    .mb-block.right { text-align: right; }
    .mb-label {
      font-size: 9px;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: #94A3B8;
      margin-bottom: 5px;
    }
    .mb-value {
      font-size: 18px;
      font-weight: 900;
      color: #D4AF37;
      letter-spacing: 0.5px;
    }
    .mb-value.dark {
      color: #1E293B;
      font-size: 13px;
      line-height: 1.5;
    }
    .status-chip {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      background: #ECFDF5;
      color: #065F46;
      font-size: 10px;
      font-weight: 900;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      padding: 7px 16px;
      border-radius: 100px;
      border: 1px solid #A7F3D0;
    }
    .status-dot {
      width: 7px; height: 7px;
      border-radius: 50%;
      background: #10B981;
      display: inline-block;
    }

    /* PERFORATION */
    .perforation {
      display: flex;
      align-items: center;
      height: 26px;
      overflow: hidden;
    }
    .perf-circle {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: #EDE9E0;
      flex-shrink: 0;
    }
    .perf-circle.l { margin-left: -13px; }
    .perf-circle.r { margin-right: -13px; }
    .perf-dashes {
      flex: 1;
      border-top: 2px dashed #E5DEC8;
    }
    .perf-tag {
      background: #D4AF37;
      color: #fff;
      font-size: 8px;
      font-weight: 900;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      padding: 5px 18px;
      border-radius: 100px;
      white-space: nowrap;
      margin: 0 8px;
    }

    /* BODY */
    .body { padding: 32px 56px; }

    .section-head {
      font-size: 9px;
      font-weight: 900;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      color: #D4AF37;
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 16px;
    }
    .section-head::after {
      content: '';
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, #E5DEC8, transparent);
    }

    .info-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 0;
    }
    .info-table tr {
      border-bottom: 1px solid #F5F2EC;
    }
    .info-table tr:last-child { border-bottom: none; }
    .info-table td {
      padding: 12px 0;
      font-size: 13px;
      vertical-align: middle;
    }
    .info-table td.lbl {
      color: #94A3B8;
      font-weight: 700;
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      width: 38%;
    }
    .info-table td.val {
      color: #1E293B;
      font-weight: 700;
      text-align: right;
    }

    .section-gap { margin-bottom: 28px; }

    .desc-block {
      background: #FAFAF7;
      border-left: 3px solid #D4AF37;
      border-radius: 0 14px 14px 0;
      padding: 18px 22px;
    }
    .desc-label {
      font-size: 9px;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: #94A3B8;
      margin-bottom: 9px;
    }
    .desc-text {
      font-size: 13px;
      color: #475569;
      line-height: 1.75;
      font-weight: 500;
    }

    /* RATING SECTION */
    .quality-row {
      display: flex;
      gap: 16px;
      align-items: stretch;
    }

    .rating-card {
      background: #1E293B;
      border-radius: 20px;
      padding: 28px 24px;
      text-align: center;
      width: 170px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
    .rc-label {
      font-size: 8px;
      font-weight: 900;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      color: rgba(255,255,255,0.35);
    }
    .rc-number {
      font-family: 'Playfair Display', serif;
      font-size: 52px;
      font-weight: 900;
      color: #fff;
      line-height: 1;
    }
    .rc-number sup {
      font-size: 18px;
      color: rgba(255,255,255,0.3);
      font-family: 'Inter', sans-serif;
      font-weight: 600;
    }
    .rc-stars { display: flex; gap: 3px; align-items: center; }

    .feedback-card {
      flex: 1;
      background: #FFFDF5;
      border: 1px solid #EFE3A8;
      border-radius: 20px;
      padding: 24px 26px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .fc-label {
      font-size: 9px;
      font-weight: 900;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: #D4AF37;
      margin-bottom: 10px;
    }
    .fc-quote {
      font-family: 'Playfair Display', serif;
      font-size: 56px;
      color: #F0E6B8;
      line-height: 0.5;
      margin-bottom: 10px;
    }
    .fc-text {
      font-size: 13px;
      color: #78350F;
      font-style: italic;
      line-height: 1.75;
      font-weight: 500;
    }

    /* FOOTER */
    .footer {
      background: #FAFAF7;
      border-top: 1px solid #F0EBD8;
      padding: 28px 56px;
    }
    .footer-inner {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    .footer-meta-lines {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    .fml {
      font-size: 9px;
      color: #B8B0A0;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    .sign-wrap { text-align: center; }
    .sign-line {
      width: 210px;
      border-top: 1.5px solid #1E293B;
      margin: 0 auto 10px;
    }
    .sign-name {
      font-size: 14px;
      font-weight: 900;
      color: #1E293B;
      letter-spacing: 0.3px;
    }
    .sign-role {
      font-size: 9px;
      color: #94A3B8;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      margin-top: 4px;
    }

    @media print {
      body { background: #fff; padding: 0; }
      .ticket { box-shadow: none; border-radius: 0; width: 100%; }
    }
  </style>
</head>
<body>
  <div class="ticket">
    <div class="watermark">ACHAL JEWELS</div>
    <div class="gold-top"></div>

    <!-- HEADER -->
    <div class="header">
      <img class="logo-img" src="${logo}" alt="Achal Jewels" />
      <div class="brand-name">Achal Jewels</div>
      <div class="brand-sub">Fine Jewellery &nbsp;·&nbsp; Jaipur &nbsp;·&nbsp; Est. Since Inception</div>
      <div class="doc-badge">Official Resolution Ticket</div>
    </div>

    <!-- META BAND -->
    <div class="meta-band">
      <div class="mb-block">
        <div class="mb-label">Ticket No.</div>
        <div class="mb-value">#${t.ticket_code}</div>
        <div style="font-size:11px;color:#94A3B8;font-weight:600;margin-top:3px;">${t.category_name}</div>
      </div>
      <div class="mb-block center">
        <div class="status-chip">
          <span class="status-dot"></span>
          Resolved
        </div>
      </div>
      <div class="mb-block right">
        <div class="mb-label">Issued On</div>
        <div class="mb-value dark">${formattedDate}</div>
      </div>
    </div>

    <!-- PERFORATION 1 -->
    <div class="perforation">
      <div class="perf-circle l"></div>
      <div class="perf-dashes"></div>
      <span class="perf-tag">Employee Details</span>
      <div class="perf-dashes"></div>
      <div class="perf-circle r"></div>
    </div>

    <!-- BODY -->
    <div class="body">

      <table class="info-table section-gap">
        <tr>
          <td class="lbl">Employee Name</td>
          <td class="val">${t.emp_name}</td>
        </tr>
        <tr>
          <td class="lbl">Contact No.</td>
          <td class="val">+91 ${t.emp_phone}</td>
        </tr>
        <tr>
          <td class="lbl">Department</td>
          <td class="val">${t.category_name}</td>
        </tr>
      </table>

    </div>

    <!-- PERFORATION 2 -->
    <div class="perforation">
      <div class="perf-circle l"></div>
      <div class="perf-dashes"></div>
      <span class="perf-tag">Incident Summary</span>
      <div class="perf-dashes"></div>
      <div class="perf-circle r"></div>
    </div>

    <div class="body">

      <table class="info-table" style="margin-bottom:20px;">
        <tr>
          <td class="lbl">Sub-Category</td>
          <td class="val">${t.subcategory_name}</td>
        </tr>
        <tr>
          <td class="lbl">Technician</td>
          <td class="val">${t.worker_name || "System Managed"}</td>
        </tr>
      </table>

      <div class="desc-block section-gap">
        <div class="desc-label">Problem Description</div>
        <div class="desc-text">${t.description || "No description provided."}</div>
      </div>

    </div>

    <!-- PERFORATION 3 -->
    <div class="perforation">
      <div class="perf-circle l"></div>
      <div class="perf-dashes"></div>
      <span class="perf-tag">Quality Audit</span>
      <div class="perf-dashes"></div>
      <div class="perf-circle r"></div>
    </div>

    <div class="body">
      <div class="quality-row">
        <div class="rating-card">
          <div class="rc-label">Customer Rating</div>
          <div class="rc-number">${t.rating}<sup>/5</sup></div>
          <div class="rc-stars">${stars(t.rating)}</div>
        </div>
        <div class="feedback-card">
          <div class="fc-label">Employee Remarks</div>
          <div class="fc-quote">&ldquo;</div>
          <div class="fc-text">${t.feedback || "Resolution verified and acknowledged by employee via mobile application."}</div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="footer">
      <div class="footer-inner">
        <div class="footer-meta-lines">
          <div class="fml">Document ID : ${docId}</div>
          <div class="fml">System Verified &middot; Achal Jewels ERP</div>
          <div class="fml">Generated : ${new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })}</div>
        </div>
        <div class="sign-wrap">
          <div class="sign-line"></div>
          <div class="sign-name">${hodName}</div>
          <div class="sign-role">Head of Department &mdash; ${t.category_name}</div>
        </div>
      </div>
    </div>

    <div class="gold-bottom"></div>
  </div>
</body>
</html>`);

    printWin.document.close();
    setTimeout(() => { printWin.print(); }, 700);
  };

  const getRatingColor = (rating) => {
    if (rating >= 4) return { bg: "#ECFDF5", color: "#065F46", border: "#A7F3D0" };
    if (rating === 3) return { bg: "#FFFBEB", color: "#92400E", border: "#FCD34D" };
    return { bg: "#FEF2F2", color: "#991B1B", border: "#FCA5A5" };
  };

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.mainContent}>

        {/* ── HEADER ── */}
        <div style={styles.header}>
          <div>
            <div style={styles.pagePill}>
              <FiAward size={12} color={GOLD} />
              <span>Quality Insights</span>
            </div>
            <h2 style={styles.title}>Service Reviews</h2>
            <p style={styles.subtitle}>Audit resolved incidents and analyze departmental satisfaction.</p>
          </div>
          <div style={styles.headerActions}>
            <div style={styles.filterGroup}>
              <FiFilter size={14} color={GOLD} />
              <select
                style={styles.filterSelect}
                onChange={(e) => setFilterRating(e.target.value)}
                value={filterRating}
              >
                <option value="All">All Ratings</option>
                {[5, 4, 3, 2, 1].map(num => (
                  <option key={num} value={num}>{"★".repeat(num)} {num} Star</option>
                ))}
              </select>
            </div>
            <button onClick={fetchReviews} style={styles.refreshBtn}>
              <FiRefreshCw size={14} className={loading ? "spin" : ""} />
              <span>Refresh</span>
            </button>
          </div>
        </div>

        {/* ── STATS ── */}
        <div style={styles.statsRow}>
          <div style={styles.statCard}>
            <div style={{ ...styles.statIconWrap, background: "#FDF8E8" }}>
              <FiStar fill={GOLD} color={GOLD} size={20} />
            </div>
            <div style={styles.statInfo}>
              <span style={styles.statLabel}>Average Rating</span>
              <span style={styles.statValue}>{avgRating} <span style={styles.statUnit}>/ 5.0</span></span>
            </div>
            <div style={styles.statAccent}>
              {[1,2,3,4,5].map(i => (
                <FiStar key={i} size={12}
                  fill={i <= Math.round(parseFloat(avgRating)) ? GOLD : "none"}
                  color={i <= Math.round(parseFloat(avgRating)) ? GOLD : "#E2E8F0"}
                />
              ))}
            </div>
          </div>

          <div style={styles.statCard}>
            <div style={{ ...styles.statIconWrap, background: "#ECFDF5" }}>
              <FiCheckCircle color="#10B981" size={20} />
            </div>
            <div style={styles.statInfo}>
              <span style={styles.statLabel}>Total Reviewed</span>
              <span style={styles.statValue}>{reviews.length}</span>
            </div>
            <div style={{ ...styles.statBadge, background: "#ECFDF5", color: "#065F46" }}>Resolved</div>
          </div>

          <div style={styles.statCard}>
            <div style={{ ...styles.statIconWrap, background: "#FDF8E8" }}>
              <FiTrendingUp color={GOLD} size={20} />
            </div>
            <div style={styles.statInfo}>
              <span style={styles.statLabel}>5-Star Reviews</span>
              <span style={styles.statValue}>{fiveStarCount}</span>
            </div>
            <div style={{ ...styles.statBadge, background: "#FDF8E8", color: "#92400E" }}>Top Rated</div>
          </div>
        </div>

        {/* ── DIVIDER ── */}
        <div style={styles.sectionDivider}>
          <span style={styles.sectionDividerText}>
            {filteredReviews.length} record{filteredReviews.length !== 1 ? "s" : ""} found
          </span>
        </div>

        {/* ── CONTENT ── */}
        {loading ? (
          <div style={styles.centeredBox}>
            <div style={styles.loaderRing}><FiRefreshCw className="spin" size={24} color={GOLD} /></div>
            <p style={styles.loaderText}>Connecting to secure database…</p>
          </div>
        ) : filteredReviews.length === 0 ? (
          <div style={styles.centeredBox}>
            <div style={styles.emptyIcon}><FiAlertCircle size={32} color="#CBD5E1" /></div>
            <p style={styles.loaderText}>No rated records found for this filter.</p>
          </div>
        ) : (
          <div style={styles.grid}>
            {filteredReviews.map((rev) => {
              const rc = getRatingColor(rev.rating);
              return (
                <div key={rev.id} style={styles.card}>
                  <div style={styles.cardTopBar}>
                    <div style={styles.ticketBadge}><FiHash size={10} /><span>{rev.ticket_code}</span></div>
                    <div style={{ ...styles.ratingBadge, background: rc.bg, color: rc.color, border: `1px solid ${rc.border}` }}>
                      {[...Array(5)].map((_, i) => (
                        <FiStar key={i} size={11}
                          fill={i < rev.rating ? "currentColor" : "none"}
                          color={i < rev.rating ? "currentColor" : "#D1D5DB"}
                        />
                      ))}
                      <span style={{ fontSize: "12px", fontWeight: 800, marginLeft: 4 }}>{rev.rating}.0</span>
                    </div>
                  </div>

                  <h3 style={styles.issueTitle}>{rev.subcategory_name}</h3>
                  <p style={styles.categoryTag}>{rev.category_name}</p>
                  <div style={styles.cardDivider} />

                  <div style={styles.metaGrid}>
                    <div style={styles.metaItem}>
                      <div style={styles.metaIcon}><FiUser size={12} color={GOLD} /></div>
                      <div>
                        <span style={styles.metaLabel}>Employee</span>
                        <span style={styles.metaValue}>{rev.emp_name}</span>
                      </div>
                    </div>
                    <div style={styles.metaItem}>
                    </div>
                    <div style={styles.metaItem}>
                      <div style={styles.metaIcon}><FiTool size={12} color={GOLD} /></div>
                      <div>
                        <span style={styles.metaLabel}>Technician</span>
                        <span style={styles.metaValue}>{rev.worker_name || "Auto Assigned"}</span>
                      </div>
                    </div>
                    <div style={styles.metaItem}>
                      <div style={styles.metaIcon}><FiCalendar size={12} color={GOLD} /></div>
                      <div>
                        <span style={styles.metaLabel}>Date</span>
                        <span style={styles.metaValue}>{new Date(rev.created_at).toLocaleDateString("en-IN")}</span>
                      </div>
                    </div>
                  </div>

                  {rev.feedback && (
                    <div style={styles.feedbackBox}>
                      <FiMessageSquare size={13} color={GOLD} style={{ flexShrink: 0, marginTop: 2 }} />
                      <p style={styles.feedbackText}>"{rev.feedback}"</p>
                    </div>
                  )}

                  <div style={styles.cardFooter}>
                    <div style={styles.resolvedPill}>
                      <span style={styles.resolvedDot} />
                      <span>Resolved</span>
                    </div>
                    <button onClick={() => downloadProfessionalTicket(rev)} style={styles.downloadBtn}>
                      <FiDownload size={13} />
                      <span>Download Ticket</span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        @keyframes spin { 100% { transform: rotate(360deg); } }
        .spin { animation: spin 0.9s linear infinite; display: inline-block; }
        * { box-sizing: border-box; }
      `}</style>
    </div>
  );
};

const styles = {
  layout: { display: "flex", background: "#F1F5F9", minHeight: "100vh", fontFamily: "'Inter', sans-serif" },
  mainContent: { marginLeft: "260px", padding: "40px 44px", flex: 1 },

  header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "36px" },
  pagePill: {
    display: "inline-flex", alignItems: "center", gap: "6px",
    background: "#FDF8E8", border: "1px solid #F3E8BB", color: "#92400E",
    fontSize: "10px", fontWeight: 800, letterSpacing: "0.5px",
    padding: "5px 12px", borderRadius: "100px", marginBottom: "12px", textTransform: "uppercase"
  },
  title: { margin: "0 0 4px 0", fontSize: "30px", fontWeight: 900, color: DARK, letterSpacing: "-0.8px", lineHeight: 1.1 },
  subtitle: { margin: 0, color: "#94A3B8", fontSize: "14px", fontWeight: 500 },
  headerActions: { display: "flex", gap: "12px", alignItems: "center", paddingTop: "4px" },
  filterGroup: {
    background: "#fff", padding: "10px 16px", borderRadius: "12px",
    border: "1px solid #E2E8F0", display: "flex", alignItems: "center", gap: "10px"
  },
  filterSelect: { border: "none", outline: "none", fontSize: "13px", fontWeight: 700, color: DARK, background: "transparent", cursor: "pointer" },
  refreshBtn: {
    background: DARK, color: "#fff", padding: "11px 20px", borderRadius: "12px",
    fontWeight: 800, fontSize: "13px", cursor: "pointer",
    display: "flex", alignItems: "center", gap: "8px", border: "none"
  },

  statsRow: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px", marginBottom: "36px" },
  statCard: {
    background: "#fff", padding: "22px 24px", borderRadius: "20px",
    border: "1px solid #E8EDF5", display: "flex", alignItems: "center",
    gap: "16px", position: "relative", overflow: "hidden"
  },
  statIconWrap: { width: "48px", height: "48px", borderRadius: "14px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  statInfo: { flex: 1, display: "flex", flexDirection: "column", gap: "2px" },
  statLabel: { fontSize: "11px", color: "#94A3B8", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px" },
  statValue: { fontSize: "26px", fontWeight: 900, color: DARK, lineHeight: 1.1 },
  statUnit: { fontSize: "14px", color: "#CBD5E1", fontWeight: 600 },
  statAccent: { display: "flex", gap: "3px", alignSelf: "flex-end" },
  statBadge: {
    position: "absolute", top: "16px", right: "16px",
    fontSize: "10px", fontWeight: 800, padding: "4px 10px",
    borderRadius: "100px", textTransform: "uppercase", letterSpacing: "0.5px"
  },

  sectionDivider: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" },
  sectionDividerText: { fontSize: "11px", fontWeight: 800, color: "#94A3B8", textTransform: "uppercase", letterSpacing: "1px" },

  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(380px, 1fr))", gap: "22px" },

  card: {
    background: "#fff", borderRadius: "22px", padding: "24px",
    border: "1px solid #EEF2F8", display: "flex", flexDirection: "column",
    boxShadow: "0 2px 12px rgba(30,41,59,0.04)"
  },
  cardTopBar: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" },
  ticketBadge: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    background: "#F8F5E8", color: "#92400E", padding: "5px 12px",
    borderRadius: "8px", fontSize: "11px", fontWeight: 900
  },
  ratingBadge: { display: "inline-flex", alignItems: "center", gap: "2px", padding: "5px 12px", borderRadius: "100px", fontWeight: 800 },
  issueTitle: { margin: "0 0 4px 0", fontSize: "18px", color: DARK, fontWeight: 800, lineHeight: 1.3, letterSpacing: "-0.3px" },
  categoryTag: { margin: "0 0 18px 0", fontSize: "12px", color: "#94A3B8", fontWeight: 600 },
  cardDivider: { height: "1px", background: "#F1F5F9", marginBottom: "18px" },

  metaGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "18px" },
  metaItem: { display: "flex", alignItems: "flex-start", gap: "10px" },
  metaIcon: {
    width: "28px", height: "28px", borderRadius: "8px", background: "#FDF8E8",
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
  },
  metaLabel: { display: "block", fontSize: "9px", color: "#94A3B8", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" },
  metaValue: { display: "block", fontSize: "12px", color: "#334155", fontWeight: 700, lineHeight: 1.3 },

  feedbackBox: {
    display: "flex", gap: "10px", background: "#FFFDF6", border: "1px solid #F3E8BB",
    padding: "14px 16px", borderRadius: "14px", marginBottom: "18px", alignItems: "flex-start"
  },
  feedbackText: { margin: 0, fontSize: "13px", color: "#78350F", fontStyle: "italic", lineHeight: 1.6, fontWeight: 500 },

  cardFooter: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    paddingTop: "16px", borderTop: "1px solid #F1F5F9", marginTop: "auto"
  },
  resolvedPill: {
    display: "inline-flex", alignItems: "center", gap: "7px",
    background: "#ECFDF5", color: "#065F46", fontSize: "11px",
    fontWeight: 800, padding: "6px 14px", borderRadius: "100px", letterSpacing: "0.3px"
  },
  resolvedDot: { width: "6px", height: "6px", borderRadius: "50%", background: "#10B981", display: "inline-block" },
  downloadBtn: {
    display: "inline-flex", alignItems: "center", gap: "7px",
    background: DARK, color: "#fff", border: "none",
    padding: "10px 20px", borderRadius: "10px", fontSize: "12px",
    fontWeight: 800, cursor: "pointer", letterSpacing: "0.3px"
  },

  centeredBox: { padding: "80px 40px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" },
  loaderRing: { width: "56px", height: "56px", borderRadius: "50%", background: "#FDF8E8", display: "flex", alignItems: "center", justifyContent: "center" },
  loaderText: { color: "#94A3B8", fontSize: "14px", fontWeight: 600, margin: 0 },
  emptyIcon: { width: "72px", height: "72px", borderRadius: "50%", background: "#F8FAFC", display: "flex", alignItems: "center", justifyContent: "center" },
};

export default Reviews;